<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" ref="modal">     
        <div class="u-window m-skin-modal">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper">
                <div class="t-skin"></div>
                <div class="dialog-body">
                    <div class="video-view">
                        <div class="player"><img src="https://web-resource.17m3.com/m3guo/202106/adshop/images/skin.gif"></div>
                    </div>
                    <div class="skill-detail">
                        <h6>R技能-护驾</h6>
                        <p>外部装备为8件【四章法术装备】或更高章节法术装备时，获得以下效果</p>
                        <p>施法期间可以再次使用【亲征】，传送到目标友军身边，在目标区域自动释放一次大招，造成75%的伤害；同时为目标周围600范围内的友军英雄单位增加【刘禅10%最大生命值】的护盾值，持续3秒</p>
                    </div>                
                </div>
            </div>         
        </div> 

        <div class="u-mask"></div>         
    </div>
</transition>       
</template>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
        }
    },
    methods : {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
    },    
}
</script>

<style scoped>
/* skin */
.m-skin-modal {
    width: 709px;
    height: 757px;
    background-image: url(~@/assets/images/utils/modal-skin.png);
}

.modal-title.t-skin {
    width: 292px;
    height: 49px;
    margin-bottom: 25px;
    background-image: url(~@/assets/images/utils/title-skin.png);
}

.video-view{
    position: relative;
    width: 602px;
    height: 340px;
    margin: 0 auto 10px;
    background-image: url(~@/assets/images/utils/bg-video.png);
}

.video-view .player{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    width: 574px;
    height: 320px;
}

.video-view .player img{
    width: 100%;
    height: 100%;
}

.skill-detail{
    width: 602px;
    margin: 0 auto;
}

.skill-detail h6{
    font-size: 28px;
    font-weight: 700;
    color: #683d1e;
    margin-bottom: 5px;
}

.skill-detail p{
    line-height: 1.6;
}
</style>


// WEBPACK FOOTER //
// src/components/SkinModal/skinModal.vue